export class ResponseRecuperarChaveAcesso {

    private emailOfuscado: string;
    private chaveAcessoOfuscado: string;
    private ip: string;

    public getEmailOfuscado(): string {
        return this.emailOfuscado;
    }

    public setEmailOfuscado(emailOfuscado: string): void {
        this.emailOfuscado = emailOfuscado;
    }

    public getChaveAcessoOfuscado(): string {
        return this.chaveAcessoOfuscado;
    }

    public setChaveAcessoOfuscado(chaveAcessoOfuscado: string): void {
        this.chaveAcessoOfuscado = chaveAcessoOfuscado;
    }

    public getIp(): string {
        return this.ip;
    }

    public setIp(ip: string): void {
        this.ip = ip;
    }

}



// WEBPACK FOOTER //
// ./src/app/resources/classes/response-recuperar-chave-acesso.ts